import React, { useState } from 'react'
import { LinkedInIcon } from './components/LinkedInIcon'
import suru from './img/suru25.jpg'

// this is such a simple thing why bring in react-router */
const App = () => {
  const [page, setPageState] = useState('home')

  const setPage = page => () => setPageState(page)

  return (
    <main>
      <div className="icons">
        <LinkedInIcon />
      </div>
      <h2 className="me">Tim Burgess</h2>
      <div className="snapcraft"></div>
      <hr />

      <div className="wrapper">
        <p className="padder">Hi, I'm Tim. I'm a software engineer and I like to build things.</p>
        <p>I've been building with front-end component technologies since early 2017.</p>
        <p>
          I've built product for companies that was then sold to larger companies, I've worked as a
          freelancer and I've led development teams.
        </p>
        <p className="padder2">
          My knowledge of CSS is extensive. I have taught HTML and CSS at university-level for
          computer science students.
        </p>
        <p className="padder2">
          This page used to be my pre-2020 contractor portfolio. Now it's just my little corner of
          the internet.
        </p>

        <p>
          I live in Dunedin, New Zealand - 4 hours after the west coast and 2 hours before Sydney
        </p>
      </div>
    </main>
  )

  // return (
  //   <CssBaseline>
  //     <Header setPage={setPage} />
  //     <div className={cx({ fixedpage: page !== 'projects' })}>
  //       {page === 'home' && <Home setPage={setPage} />}
  //       {page === 'projects' && <Projects setPage={setPage} />}
  //       {page === 'about' && <About setPage={setPage} />}
  //       {page === 'contact' && <Contact setPage={setPage} />}
  //     </div>
  //   </CssBaseline>
  // )
}

export default App
